import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';
import {useState} from "react";

import Alert from '@mui/material/Alert';
import Avatar from '@mui/material/Avatar';
import FileIcon from '@mui/icons-material/InsertDriveFile';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid2 from "@mui/material/Unstable_Grid2";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import BlankContent from '../common/BlankContent';
import SessionTypeListItem from './SessionTypeListItem';
import VacationTimeEditor from './VacationTimeEditor';
import useIsMobile from "../../hooks/useIsMobile";
import config from '../../config/config';
import { getPublicProfileUrl } from '../../helpers/providers';

const BlankStateContent = props => (
  <BlankContent
    title='No sessions set up'
    body='Your session types are the different services you offer. These will be viewable by all patients for scheduling.'
    Icon={FileIcon}
    ButtonComponent={
      <Button
          variant='primaryGradient'
          color='primary'
          size={props.isMobile ? 'medium' : 'large'}
          onClick={props.onCreateSessionType}
          style={{marginTop: '4em'}}
      >
        New Session Type
      </Button>
    }
  />
);

const ListSessionTypes = props => {
  const {provider} = props;
  const [hasVacationTime, setHasVacationTime] = useState(false);
  const navigate = useNavigate();
  const handleVacationEditorEvent = (hasVacation) => {
    setHasVacationTime(hasVacation);
  };
  const hasVisibleSessionTypes = (props.sessionTypes || []).some(s => s.hide_from_patients === false);
  return (
    <Box>
      <Stack spacing={2} paddingTop={2}>
        <Stack direction='row' spacing={1} style={{paddingTop: '1em'}}>
          <Avatar
            alt={`${provider.first_name} ${provider.last_name}`}
            src={provider.imgSrc}
            sx={{backgroundColor: config().colors.blue}}
          />
          <Stack alignItems='flex-start'>
            <Typography variant='h2'>
              {provider.first_name} {provider.last_name}
            </Typography>
            <Button
              style={{padding: '0px'}}
              onClick={() => navigate(getPublicProfileUrl(provider))}
            >
            <Typography variant='large'>
              View Profile
            </Typography>
            </Button>
          </Stack>
        </Stack>
        <Divider/>
        {!hasVisibleSessionTypes &&
          <Alert severity='error' paddingTop={0.5}>
            <Typography variant='body1' style={{paddingTop: '0em'}}>
              <strong>None of your session types are visible to patients!</strong>{' '}
              Please ensure that you turn on the visibility for schedules to be shown to patients.
            </Typography>
          </Alert>
        }
        <Stack flexWrap={hasVacationTime ? '': 'wrap'} useFlexGap
               direction={hasVacationTime? 'column': 'row'}
               justifyContent={'right'}
               alignItems={'flex-end'}
               padding={1}
               spacing={2}>
          <Button
              variant='primaryGradient'
              size={props.isMobile ? 'medium' : 'large'}
              color='primary'
              onClick={props.onCreateSessionType}
          >
            New Session Type
          </Button>
          <VacationTimeEditor isMobile={props.isMobile} onEvent={handleVacationEditorEvent} />
        </Stack>
        <Grid2 container spacing={2}>
          {
            (props.sessionTypes || []).map(s =>
                <Grid2 xs={12} lg={6} xl={4}>
                  <SessionTypeListItem
                      key={s.id}
                      sessionType={s}
                      onEdit={() => props.onEdit({id: s.id})}
                      onDelete={() => props.onDelete({id: s.id})}
                      onShow={() => props.onShow({id: s.id})}
                      onHide={() => props.onHide({id: s.id})}
                  />
                </Grid2>
            )
          }
        </Grid2>
      </Stack>
    </Box>
  );
};

const ListSessionTypesScreen = props => {
  const isMobile = useIsMobile();
  const combinedProps = { ...props, isMobile };
  return (
    <Box>
      {
        !props.sessionTypes || !props.sessionTypes.length
        ? <BlankStateContent {...combinedProps} />
        : <ListSessionTypes {...combinedProps} />
      }
    </Box>
  );
};

ListSessionTypesScreen.defaultProps = {

};

ListSessionTypesScreen.propTypes = {
  sessionTypes: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
  })),
  onCreateSessionType: PropTypes.func,
};

export default ListSessionTypesScreen;
